// @flow
import * as React from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {FormattedMessage} from 'react-intl';

import {GENERIC_EVENT} from '../../utils/edapWrapper';

import FlexibleDatesDesktop from './FlexibleDatesDesktop';
import FlexibleDatesMobile from './FlexibleDatesMobile';

export type FlexibleDateRange = {
    startDate: string,
    endDate: string
};

type onDateChangeWrapperArgs = FlexibleDateRange & {
    eventlabel: string
};

export type FlexibleDatesOptionProps = {
    days: number,
    id: string,
    label: string
};

export type FlexibleDatesOptionExtraProps = FlexibleDateRange & {
    loading: boolean,
    locale: string,
    onDateChange: (args: onDateChangeWrapperArgs) => void,
    resultCount?: number
};

export type FlexibleDatesOptions = {
    sub: Array<FlexibleDatesOptionProps>,
    add: Array<FlexibleDatesOptionProps>
};

type Props = {
    startDate: string,
    endDate: string,
    locale: string,
    loading: boolean,
    isDesktop: boolean,
    onDateChange: (arrival: string, departure: string) => void,
    options: FlexibleDatesOptions,
    resultCount?: number
};

export type FlexibleDatesDesktopMobileProps = FlexibleDatesOptionExtraProps & {
    title: React.Node,
    options: FlexibleDatesOptions
};

function FlexibleDates({
    startDate,
    endDate,
    onDateChange,
    isDesktop,
    ...props
}: Props) {
    // $FlowFixMe
    const [internalStartDate, setInternalStartDate] = React.useState(startDate);
    // $FlowFixMe
    const [internalEndDate, setInternalEndDate] = React.useState(endDate);

    // $FlowFixMe
    const trackingContext = React.useContext(TrackingContext);

    // Keep track of dates changed outside the component
    // $FlowFixMe
    React.useEffect(() => {
        setInternalStartDate(startDate);
        setInternalEndDate(endDate);
    }, [startDate, endDate]);

    function onDateChangeWrapper({
        startDate: newStartDate,
        endDate: newEndDate,
        eventlabel
    }) {
        setInternalStartDate(newStartDate);
        setInternalEndDate(newEndDate);

        const arrival = newStartDate;
        const departure = newEndDate;
        trackingContext.trigger(GENERIC_EVENT, {
            eventaction: 'search',
            eventlabel
        });

        onDateChange(arrival, departure);
    }

    const titleTranslated = (
        <FormattedMessage
            id="flexibleDatesTitle1"
            defaultMessage="Flexible dates? See more options"
        />
    );

    const commonProps = {
        ...props,
        startDate: internalStartDate,
        endDate: internalEndDate,
        onDateChange: onDateChangeWrapper,
        title: titleTranslated
    };

    return isDesktop ? (
        <FlexibleDatesDesktop {...commonProps} />
    ) : (
        <FlexibleDatesMobile {...commonProps} />
    );
}

FlexibleDates.defaultProps = {
    loading: false,
    options: {
        sub: [
            {
                days: 7,
                label: '1 week earlier',
                id: 'OneWeekEarlier'
            },
            {
                days: 1,
                label: '1 day earlier',
                id: 'OneDayEarlier'
            }
        ],
        add: [
            {
                days: 1,
                label: '1 day later',
                id: 'OneDayLater'
            },
            {
                days: 7,
                label: '1 week later',
                id: 'OneWeekLater'
            }
        ]
    },
    locale: 'us'
};

export default FlexibleDates;
